/**
 * Сессия кончилась: чистим токен и уводим на вход.
 *
 * Просроченный токен API отдаёт как 403 с текстом
 * «provided JWT is trying to be used after "exp" claim» — это сообщение
 * из библиотеки, и показывать его человеку нельзя. 401 приходит, когда
 * токена нет вовсе. Оба случая для пользователя одинаковы: надо войти заново.
 */
export const isAuthError = (status, message) =>
  status === 401 ||
  (status === 403 && typeof message === "string" && message.includes("exp"));

export const dropSession = () => {
  localStorage.removeItem("token");
  localStorage.setItem("login", false);

  const login = `${process.env.PUBLIC_URL || ""}/login`;
  if (window.location.pathname !== login) {
    window.location.href = login;
  }
};
